const BaseUrl = "https://salon-booking-software.logicspice.in/api";
// const BaseUrl = "http://127.0.0.1:8000/api";
export default BaseUrl;